import { PageTitleModule } from './../../app/components/page-title/page-title.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
	exports: [
		PageTitleModule,
	],
  imports: [
    CommonModule
  ]
})
export class PageSharedModule { }
